export default __webpack_public_path__ + "static/media/expleo.d0f2b97c.png";